import styled from 'styled-components/macro';

const Shaded = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .6);
`;

const Overlay = styled(({className, children, onClose}) => (
    <div className={className}>
        <Shaded onClick={onClose} />
        {children}
    </div>
))`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default Overlay;
